import { useSeo } from '@/hooks/useSeo';
import { homeFaqs, hotRank, siteInfo } from '@/mocks/feed';
import HeroSection from './components/HeroSection';
import LiveTicker from './components/LiveTicker';
import HotBoard from './components/HotBoard';
import LatestFeed from './components/LatestFeed';
import SlotSection from './components/SlotSection';
import TopicSection from './components/TopicSection';
import TrustSection from './components/TrustSection';
import SubscribeSection from './components/SubscribeSection';
import FaqAccordion from '@/components/feature/FaqAccordion';
import SectionHeading from '@/components/base/SectionHeading';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: `${siteInfo.domain}/`,
    inLanguage: 'zh-CN',
    description: siteInfo.desc,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteInfo.domain}/feed?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: `${siteInfo.domain}/`,
    email: siteInfo.email,
    description: '按午夜、凌晨、后半夜整理正在发酵的娱乐话题，提供时间线与热度参考。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: homeFaqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '夜间实时热榜',
    itemListElement: hotRank.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.title,
      url: `${siteInfo.domain}/article/${item.slug}`,
    })),
  },
];

export default function Home() {
  useSeo({
    title: '夜半瓜社｜深夜黑料与午夜话题情报站',
    description:
      '夜半瓜社专注深夜黑料与午夜话题整理，午夜、凌晨、后半夜通宵在线盯动向，把正在发酵的娱乐话题按时间线梳理清楚，睡不着就来瓜田逛一圈。',
    keywords: '深夜黑料,午夜话题,后半夜吃瓜,凌晨情报,通宵失眠陪伴',
    path: '/',
    ogType: 'website',
    jsonLd,
  });

  return (
    <>
      <HeroSection />
      <LiveTicker />
      <HotBoard />
      <LatestFeed />
      <SlotSection />
      <TopicSection />
      <TrustSection />

      <section className="border-t border-background-200/70 bg-background-100/40">
        <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
          <SectionHeading
            eyebrow="FAQ"
            title="关于深夜黑料，你可能想问的"
            desc="这些问题我们被问过很多次，统一在这里回答，也方便新来的读者快速了解我们的处理方式。"
          />
          <FaqAccordion items={homeFaqs} />
        </div>
      </section>

      <SubscribeSection />
    </>
  );
}